// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_updateAgentProfileAvatarV2(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["Agent"]);
}

let variablesConverter = {"profilePhotoWithOriginalInput":{"originalPhoto":{"r":"profilePhotoInput"},"croppedPhoto":{"r":"profilePhotoInput"}},"updateAgentProfileAvatarV2Input":{"avatar":{"r":"profilePhotoWithOriginalInput"}},"profilePhotoInput":{},"__root":{"input":{"r":"updateAgentProfileAvatarV2Input"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"updateAgentProfileAvatarV2_Agent":{"f":""},"updateAgentProfileAvatarV2":{"u":"response_updateAgentProfileAvatarV2"}}};

let wrapResponseConverterMap = {
  response_updateAgentProfileAvatarV2: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"updateAgentProfileAvatarV2_Agent":{"f":""},"updateAgentProfileAvatarV2":{"u":"response_updateAgentProfileAvatarV2"}}};

let responseConverterMap = {
  response_updateAgentProfileAvatarV2: unwrap_response_updateAgentProfileAvatarV2
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function imageContentType_decode($$enum) {
  if ($$enum === "GIF" || $$enum === "WEBP" || $$enum === "JPEG" || $$enum === "PNG") {
    return $$enum;
  }
}

let imageContentType_fromString = imageContentType_decode;

let Utils = {
  imageContentType_decode: imageContentType_decode,
  imageContentType_fromString: imageContentType_fromString
};

let providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v5 = {
  "kind": "Variable",
  "name": "ratio",
  "variableName": "__relay_internal__pv__DevicePixelRatio"
},
v6 = {
  "kind": "Literal",
  "name": "width",
  "value": 60
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SharingProfileMiniFormProfilePhotoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateAgentProfileAvatarV2",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SharingProfileMiniFormProfilePhoto_agent"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SharePropertyWithPreviewRelay_agent"
              },
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProfilePhoto",
                  "kind": "LinkedField",
                  "name": "profilePhoto",
                  "plural": false,
                  "selections": [
                    (v3/*: any*/),
                    (v4/*: any*/)
                  ],
                  "storageKey": null
                },
                "action": "NONE"
              }
            ],
            "type": "Agent",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "SharingProfileMiniFormProfilePhotoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateAgentProfileAvatarV2",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfilePhoto",
                "kind": "LinkedField",
                "name": "profilePhoto",
                "plural": false,
                "selections": [
                  {
                    "alias": "photoUrl",
                    "args": [
                      (v5/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "width",
                        "value": 96
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": [
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ],
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  {
                    "alias": "urlWithRing",
                    "args": [
                      (v5/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "ring",
                        "value": true
                      },
                      (v6/*: any*/)
                    ],
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  {
                    "alias": "sidecardUrl",
                    "args": [
                      (v5/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "width",
                        "value": 120
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "brokerage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "membershipStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailAddress",
                "storageKey": null
              }
            ],
            "type": "Agent",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4773d584eeef3919d9abf7c86e205d31",
    "id": null,
    "metadata": {},
    "name": "SharingProfileMiniFormProfilePhotoMutation",
    "operationKind": "mutation",
    "text": "mutation SharingProfileMiniFormProfilePhotoMutation(\n  $input: UpdateAgentProfileAvatarV2Input!\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  updateAgentProfileAvatarV2(input: $input) {\n    __typename\n    ... on Agent {\n      ...SharingProfileMiniFormProfilePhoto_agent\n      ...SharePropertyWithPreviewRelay_agent\n      profilePhoto {\n        id\n        key\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      __typename\n      nodeId\n    }\n  }\n}\n\nfragment AgentInfo_agent on Agent {\n  id\n  displayName\n  brokerage\n  profilePhoto {\n    url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio)\n    urlWithRing: url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio, ring: true)\n  }\n  membershipStatus\n}\n\nfragment SharePropertyFormRelay_agent on Agent {\n  ...SharingEditableProfileInfoRelay_agent\n}\n\nfragment SharePropertyPreviewRelayForSaleProperty_agent on Agent {\n  ...SharedPropertySidecard_agent\n}\n\nfragment SharePropertyPreviewRelayMessage_agent on Agent {\n  ...SharedPropertyMessage_AgentInfo_agent\n}\n\nfragment SharePropertyPreviewRelayRentalProperty_agent on Agent {\n  ...SharedPropertySidecard_agent\n}\n\nfragment SharePropertyPreviewRelay_agent on Agent {\n  ...SharePropertyPreviewRelayMessage_agent\n  ...SharePropertyPreviewRelayForSaleProperty_agent\n  ...SharePropertyPreviewRelayRentalProperty_agent\n  ...VerifiedAgentCard_Agent\n}\n\nfragment SharePropertyWithPreviewRelay_agent on Agent {\n  ...SharePropertyFormRelay_agent\n  ...SharePropertyPreviewRelay_agent\n  displayName\n}\n\nfragment SharedPropertyMessage_AgentInfo_agent on Agent {\n  displayName\n  brokerage\n  profilePhoto {\n    url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio)\n  }\n  membershipStatus\n}\n\nfragment SharedPropertySidecard_agent on Agent {\n  displayName\n  profilePhoto {\n    sidecardUrl: url(width: 120, ratio: $__relay_internal__pv__DevicePixelRatio)\n  }\n  emailAddress\n}\n\nfragment SharingEditableProfileInfoRelay_agent on Agent {\n  ...SharingProfileMiniFormRelay_agent\n  ...AgentInfo_agent\n}\n\nfragment SharingProfileMiniFormProfilePhoto_agent on Agent {\n  firstName\n  displayName\n  ...SharingProfileMiniFormProfilePhoto_currentPhoto_agent\n  ...SharingProfileMiniFormProfilePhoto_changeProfilePhoto_agent\n}\n\nfragment SharingProfileMiniFormProfilePhoto_changeProfilePhoto_agent on Agent {\n  id\n  profilePhoto {\n    __typename\n  }\n}\n\nfragment SharingProfileMiniFormProfilePhoto_currentPhoto_agent on Agent {\n  profilePhoto {\n    photoUrl: url(width: 96, ratio: $__relay_internal__pv__DevicePixelRatio)\n    id\n  }\n}\n\nfragment SharingProfileMiniFormRelay_agent on Agent {\n  ...SharingProfileMiniFormProfilePhoto_agent\n  firstName\n  lastName\n  displayName\n  brokerage\n}\n\nfragment VerifiedAgentCard_Agent on Agent {\n  brokerage\n  displayName\n  profilePhoto {\n    sidecardUrl: url(width: 120, ratio: $__relay_internal__pv__DevicePixelRatio)\n  }\n  emailAddress\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

let node = makeNode(providedVariablesDefinition);

let wrap_response_updateAgentProfileAvatarV2 = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_updateAgentProfileAvatarV2 = unwrap_response_updateAgentProfileAvatarV2;
exports.wrap_response_updateAgentProfileAvatarV2 = wrap_response_updateAgentProfileAvatarV2;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
/* node Not a pure module */
